module.exports = __webpack_public_path__ + "img/volunteer_rus_country.39c77533.svg";